import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client";
import LocalStorageService from "../services/localstorage.service";
import { HeaderType } from "../types/headers";

const client = new HTTPClient();

export interface HeadersFilters {
    page: number;
    limit: number;
    name: string;
}

export interface ResponseType {
    headers?: {
        data: Array<HeaderType>;
    };
    total?: number;
    error?: string;
}

export interface HeaderForm {
    id?: number;
    headerData: any;
    templateId: number;
}

interface RawResponse {
    success: boolean;
    error: any;
  }

class HeadersModel {
    static async find(headerId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
           `${AUTH_URL}/headers/${headerId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }

    static async saveHeader(data: HeaderForm){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            data.id ? RequestType.PUT : RequestType.POST,
            data.id ? `${AUTH_URL}/headers/${data.id}` : `${AUTH_URL}/headers`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response =  data.id ? await client.put(request) : await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as RawResponse
    }

    static async getAll(filters: HeadersFilters){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/headers?page=${filters.page}&limit=${filters.limit}&name=${filters.name}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }
}

export default HeadersModel